import { cn } from "utils/cn";

import CardEffect from "./CardEffect";
import styles from "./documentation-card.module.css";

interface DocumentationCardProps {
  title: string;
  description: string;
  downloadLink: string;
  downloadText: string;
}

export const DocumentationCard = ({
  title,
  description,
  downloadLink,
  downloadText,
}: DocumentationCardProps) => {
  return (
    <div className={cn(styles.spaceCardContainer, "w-max h-max")}>
      <div className="flex justify-center px-6 py-9 w-[350px] h-[300px]">
        <div className="flex flex-col gap-4 justify-between">
          <div className="flex flex-col gap-4 h-20">
            <p className="font-semibold text-base font-orbitron tracking-[0.07em]">
              {title}
            </p>
            <p className="text-sm leading-snug tracking-[0.07em] font-inter">
              {description}
            </p>
          </div>

          <div className="flex justify-center">
            <CardEffect />
          </div>

          <div className="flex flex-row justify-center">
            <a
              href={downloadLink}
              className="flex items-center gap-2 px-4 py-2 font-semibold text-sm font-inter tracking-[0.07em]"
              target="_blank"
              rel="noreferrer"
            >
              <div className="w-4 h-4 bg-primary shadow-[0_0_5px_#2DE8F4] rounded-sm flex items-center justify-center">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 10 9"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.92627 5.8125V7.47917C8.92627 7.70018 8.83847 7.91214 8.68219 8.06842C8.52591 8.2247 8.31395 8.3125 8.09294 8.3125H2.2596C2.03859 8.3125 1.82663 8.2247 1.67035 8.06842C1.51407 7.91214 1.42627 7.70018 1.42627 7.47917V5.8125M3.09294 3.72917L5.17627 5.8125M5.17627 5.8125L7.2596 3.72917M5.17627 5.8125V0.8125"
                    stroke="#09090B"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              {downloadText}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
